import { render, staticRenderFns } from "./Sabermas.vue?vue&type=template&id=2b0db28c&scoped=true&"
import script from "./Sabermas.vue?vue&type=script&lang=js&"
export * from "./Sabermas.vue?vue&type=script&lang=js&"
import style0 from "./Sabermas.vue?vue&type=style&index=0&id=2b0db28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0db28c",
  null
  
)

export default component.exports